import clsx from "clsx";
import PropTypes from "prop-types";
import * as React from "react";
import resolveSpacing from "../../utils/spacing";
import css from "./Box.module.css";

const WRAP_MAP = {
  true: "wrap",
  false: "nowrap",
};

const resolveWrap = (wrap) => {
  if (wrap == null) return undefined;
  return WRAP_MAP[wrap] ?? String(wrap);
};

const Box = React.forwardRef(
  (
    {
      direction,
      wrap,
      gap,
      align,
      justify,
      padding,
      as: Component = "div",
      className,
      style,
      children,
      ...rest
    },
    ref,
  ) => {
    const customProperties = Object.fromEntries(
      Object.entries({
        "--box-direction": direction,
        "--box-wrap": resolveWrap(wrap),
        "--box-gap": resolveSpacing(gap),
        "--box-align": align,
        "--box-justify": justify,
        "--box-padding": resolveSpacing(padding),
      }).filter(([, v]) => v !== undefined),
    );

    return (
      <Component
        ref={ref}
        className={clsx(css.root, className)}
        style={{ ...customProperties, ...style }}
        {...rest}
      >
        {children}
      </Component>
    );
  },
);

Box.displayName = "Box";

Box.propTypes = {
  direction: PropTypes.oneOf([
    "row",
    "column",
    "row-reverse",
    "column-reverse",
  ]),
  wrap: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.oneOf(["wrap", "nowrap", "wrap-reverse"]),
  ]),
  gap: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  align: PropTypes.string,
  justify: PropTypes.string,
  padding: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  as: PropTypes.elementType,
  className: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.node,
};

export default Box;
